// extracted by mini-css-extract-plugin
export default {"background_pic":"LinkmanDetail_background_pic__VtH6V"};